import styled from 'styled-components'

// Components
import Button from 'components/Button'

export const FormFieldRow = styled.div`
  display: flex;
  flex-direction: row;

  & > input {
    min-width: 0;
    flex: 1;
  }

  & > button {
    flex: 0;
  }
`

export const ApprovedLabel = styled.span`
  margin-left: 4px;
  margin-bottom: 2px; /* stylelint-disable-line scales/space */
  color: ${({ theme }) => theme.colors.state.positive};
  font-size: ${({ theme }) => theme.fontSizes.small};
`

export const StyledButton = styled(Button)`
  margin-left: 12px;
`

export const ApprovedWrapper = styled.div`
  display: flex;
  align-items: center;
  flex-direction: row;
  margin-left: 20px;
  color: ${({ theme }) => theme.colors.state.positive};
`

export const ShortnameWrapper = styled.div`
  margin-top: 44px;
  margin-bottom: 12px;
  padding-bottom: 32px;
  border-bottom: 1px solid ${({ theme }) => theme.colors.border[1]};
`

export const TabsWrapper = styled.div`
  margin-top: 32px;
`
